import axios from "axios";

/** Достаёт текст ошибки из ответа бэкенда (NestJS ValidationPipe/HttpException). */
export function getApiErrorMessage(e: unknown, fallback: string): string {
  if (axios.isAxiosError(e)) {
    const data = e.response?.data as { message?: string | string[] } | undefined;
    const message = Array.isArray(data?.message) ? data?.message[0] : data?.message;
    if (message) return message;
  }
  return fallback;
}
